document.addEventListener('alpine:init', () => {
  Alpine.data('CustomDrawerCart', () => {
    return {
      cart: null,
      loading: true,
      updating: null,

      init() {
        // Register cart with modal store
        Alpine.store('modals').register('cart', 'rightDrawer');

        // Listen for add-to-cart events to auto-open
        document.body.addEventListener(
          'shapes:modalcart:afteradditem',
          () => {
            this.fetchCart().then(() => {
              Alpine.store('modals').open('cart');
            });
          }
        );

        // Also re-fetch when drawer opens (e.g. clicking cart icon)
        document.body.addEventListener('cart-is-open', () => {
          this.fetchCart();
        });

        // Fetch initial cart data
        this.fetchCart();
      },

      async fetchCart() {
        try {
          const res = await fetch('/cart.js', {
            headers: { 'Content-Type': 'application/json' },
          });
          this.cart = await res.json();
          Alpine.store('cart_count').count = this.cart.item_count;
        } catch (error) {
          console.error('Error fetching cart:', error);
        } finally {
          this.loading = false;
        }
      },

      async updateQuantity(key, quantity) {
        this.updating = key;

        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity }),
          });
          const data = await res.json();

          if (data.status === 422) {
            console.error('Cart update error:', data.message);
            this.updating = null;
            return;
          }

          this.cart = data;
          Alpine.store('cart_count').count = data.item_count;
        } catch (error) {
          console.error('Error updating cart:', error);
        } finally {
          this.updating = null;
        }
      },

      removeItem(key) {
        this.updateQuantity(key, 0);
      },

      increment(key, currentQty) {
        this.updateQuantity(key, currentQty + 1);
      },

      decrement(key, currentQty) {
        if (currentQty > 1) {
          this.updateQuantity(key, currentQty - 1);
        }
      },

      formatMoney(cents) {
        if (typeof formatMoney === 'function') {
          return formatMoney(cents, theme.moneyFormat);
        }
        return '$' + (cents / 100).toFixed(2);
      },

      get itemCount() {
        return this.cart ? this.cart.item_count : 0;
      },

      get subtotal() {
        return this.cart ? this.cart.total_price : 0;
      },

      get isEmpty() {
        return !this.cart || this.cart.item_count === 0;
      },

      getFlavorText(item) {
        // Try to extract flavor from variant options
        if (item.variant_options && item.variant_options.length > 0) {
          return item.variant_options[0];
        }
        if (
          item.variant_title &&
          item.variant_title !== 'Default Title'
        ) {
          return item.variant_title.split(' / ')[0];
        }
        return null;
      },

      getSubtitleText(item) {
        // Use product type or second part of variant title
        if (item.product_type) {
          return item.product_type;
        }
        return '';
      },

      getItemImage(item) {
        if (item.featured_image && item.featured_image.url) {
          return item.featured_image.url + '&width=200';
        }
        if (item.image) {
          // item.image is already a URL string
          return item.image.replace(/(\.\w+)(\?|$)/, '$1?width=200$2');
        }
        return '';
      },
    };
  });
});
